<section-title [icon]="'attach_money'" [text]="'Total Crypto Assets'"></section-title>
<mat-card [ngClass]="empty(assets) ? 'no-data-container widget' : 'widget'">
    <mat-card-content>
        <div *ngIf="empty(assets)" class="no-data">No data</div>
        <div id="walletBalanceChart" *ngIf="!empty(assets)">
            <apx-chart
                [chart]="walletBalanceChartOptions.chart"
                [legend]="walletBalanceChartOptions.legend"
                [series]="walletBalanceChartOptions.series"
                [labels]="walletBalanceChartOptions.labels"
                [plotOptions]="walletBalanceChartOptions.plotOptions"
                [annotations]="walletBalanceChartOptions.annotations"
                [dataLabels]="walletBalanceChartOptions.dataLabels"
                [tooltip]="walletBalanceChartOptions.tooltip">
            </apx-chart>
        </div>
    </mat-card-content>
</mat-card>